import {Theme} from '@emotion/react';
import DownloadIcon from '@mui/icons-material/Download';
import {LoadingButton} from '@mui/lab';
import {SxProps} from '@mui/material';
import {localized} from 'i18n/i18n';
import {FC, memo} from 'react';
import {excelDownloadButtonColor} from 'styles/color-constants';

interface Props {
  isLoading: boolean;
  name?: string;
  url?: string;
  download: () => Promise<void>;
  reference: React.MutableRefObject<HTMLAnchorElement | null>;
}

export const DownloadExcelButton: FC<Props> = memo((props) => {
  const iconStyles: SxProps<Theme> = {fontSize: '1.5rem', color: excelDownloadButtonColor, ml: 1};

  return (
    <LoadingButton sx={{marginLeft: 1}} loading={props.isLoading} onClick={props.download}>
      {localized('ExportExcel')}
      <DownloadIcon sx={iconStyles} />
      <a href={props.url} download={props.name} className="hidden" ref={props.reference}>
        <></>
      </a>
    </LoadingButton>
  );
});
